import styled from 'styled-components'

const EmployeeTimesheetSc = styled.div`
  width: 90vw;
  position: absolute;
  top: 55px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;

  .employee-container {
    display: flex;
    flex-direction: column;
    width: 80vw;
  }

  .member-performance-list {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    margin-bottom: 1rem;
    padding: 1rem;
    display: flex;
    flex-direction: column;
  }

  .profile-container {
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
  }

  .employee-image {
    width: 50px;
    height: 50px;
    background-color: #dedede;
    border-radius: 25px;
    margin-right: 1rem;
  }

  .employee-name {
    font-size: 1.2rem;
    font-weight: bold;
    color: #333;
  }

  .employee-list {
    font-size: 1rem;
    color: #666;
  }

  .performance-status {
    display: flex;
    justify-content: flex-end;
  }

  .project-lead-approval-status {
    cursor: pointer;
    padding: 0.5rem 1rem;
    background-color: #0056b3;
    color: white;
    border-radius: 5px;
    text-align: center;
    max-width: 120px;
  }

  .project-lead-approval-status:hover {
    background-color: #004494;
  }

  .alert-messages {
    text-align: center;
    color: #d9534f;
    padding: 1rem;
    border: 1px solid #d9534f;
    border-radius: 5px;
    margin-top: 2rem;
  }
`
export default EmployeeTimesheetSc
